export default __webpack_public_path__ + "static/media/arrow-up.41a73bdc.svg";